<template>
  <div class="cms-news-list">
    <template v-if="hasResults">
      <ul class="cms-news-list__content">
        <cms-news-list-item v-for="item in items"
                            :key="item.NewsItemId"
                            :title="item.Title"
                            :image-url="item.ImageUrl"
                            :summary="item.Summary"
                            :is-direct-link="item.IsDirectLink"
                            :generated-link-url="item.GeneratedLinkUrl"
                            :date="item.Date"
                            :is-pinned="item.IsPinned"
        />
      </ul>
      <div>
        <pagination-control :model-value="paginatorCurrentPage"
                            @update:modelValue="onPageClicked"
                            :total-rows="totalItemsFound"
                            :per-page="10"
        />
      </div>
    </template>
    <empty-results v-else
                   class="cms-news-list__content"
                   :error-description="$res.Views.CmsNewsItem_EmptyResults"/>
  </div>
</template>

<script>
import CmsNewsListItem from "./CmsNewsListItemComponent.vue"
import PaginationControl from "@/common/controls/PaginationControl.vue";
import EmptyResults from "@/common/EmptyResultsComponentDesktop.vue";

export default {
  components: {
    CmsNewsListItem,
    PaginationControl,
    EmptyResults,
  },
  props: {
    items: Array,
    paginatorCurrentPage: {type: Number, default: 1},
    paginatorHrefTextPrefix: String,
    totalItemsFound: Number,
    itemsOnPage: Number,
  },
  computed: {
    hasResults() {
      return this.items && this.items.length > 0;
    },
  },
  methods: {
    onPageClicked(page) {
      this.$emit('paginator-page-changed', page);
    }
  }
}
</script>


<style lang="scss" scoped>
.cms-news-list__content {
  display: flex;
  flex-flow: column;
  gap: 20px;
  list-style-type: none;
}
</style>
